module.exports = __webpack_public_path__ + "img/db.41d777a2.jpg";